import { render, staticRenderFns } from "./CashierInvoices.vue?vue&type=template&id=db8bb25c&scoped=true"
import script from "./CashierInvoices.vue?vue&type=script&lang=js"
export * from "./CashierInvoices.vue?vue&type=script&lang=js"
import style0 from "./CashierInvoices.vue?vue&type=style&index=0&id=db8bb25c&prod&lang=scss&scoped=true"
import style1 from "./CashierInvoices.vue?vue&type=style&index=1&id=db8bb25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8bb25c",
  null
  
)

export default component.exports